import React from "react";
import { SingleSelectRedux } from "@learningblocks/simulations/shared-components";

export function DialysisSingleSelect(props) {
  if (props.concentration != props.displayConcentration) {
    return <></>;
  } else {
    return (
      <SingleSelectRedux
        {...props}
        key={props.id}
        className={props.className}
      />
    );
  }
}

DialysisSingleSelect.propTypes = {};
